module.exports = __webpack_public_path__ + "img/6-text.55bb0126.png";